import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from '@carrent/core'
import { authApi, getAccessToken, getRefreshToken, clearTokens } from '@carrent/api'
import { DriverLayout } from './layout/DriverLayout'

import LoginPage from './pages/auth/LoginPage'
import RegisterPage from './pages/auth/RegisterPage'

import DriverHome from './pages/driver/DriverHome'
import CarsPage from './pages/driver/CarsPage'
import TripsPage from './pages/driver/TripsPage'
import TripDetailPage from './pages/driver/TripDetailPage'
import ProfilePage from './pages/driver/ProfilePage'
import MorePage from './pages/driver/MorePage'
import KbSpacesPage from './pages/driver/kb/KbSpacesPage'
import KbSpacePage from './pages/driver/kb/KbSpacePage'
import KbArticlePage from './pages/driver/kb/KbArticlePage'
import QueuePage from './pages/driver/QueuePage'
import VideoCallsScreen from './pages/driver/VideoCallsScreen'
import VerificationWizard from './pages/driver/VerificationWizard'
import NotificationsPage from './pages/driver/NotificationsPage'
import ChatListPage from './pages/driver/chat/ChatListPage'
import ChatPage from './pages/driver/chat/ChatPage'
import SavedPage from './pages/driver/chat/SavedPage'
import SupportPage from './pages/driver/SupportPage'
import CreateTicketPage from './pages/driver/CreateTicketPage'
import TicketChat from './pages/common/TicketChat'

import TasksPage from './pages/tasks/TasksPage'
import TaskCreatePage from './pages/tasks/TaskCreatePage'
import TaskDetailPage from './pages/tasks/TaskDetailPage'

function FullPageSpinner() {
  return (
    <div className="full-page-center">
      <div className="spinner" />
    </div>
  )
}

function RequireAuth({ children }) {
  const { user, isLoading } = useAuthStore()
  if (isLoading) return <FullPageSpinner />
  if (!user) return <Navigate to="/login" replace />
  return children
}

function RequireGuest({ children }) {
  const { user, isLoading } = useAuthStore()
  if (isLoading) return <FullPageSpinner />
  if (user) return <Navigate to="/" replace />
  return children
}

export default function App() {
  const { login, setLoading } = useAuthStore()

  useEffect(() => {
    const token = getAccessToken()
    if (!token) {
      setLoading(false)
      return
    }
    authApi
      .me()
      .then(({ data }) => login(data.data, token, getRefreshToken()))
      .catch(clearTokens)
      .finally(() => setLoading(false))
  }, [])

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<RequireGuest><LoginPage /></RequireGuest>} />
        <Route path="/register" element={<RequireGuest><RegisterPage /></RequireGuest>} />

        <Route path="/" element={<RequireAuth><DriverLayout /></RequireAuth>}>
          <Route index element={<DriverHome />} />
          <Route path="trips" element={<TripsPage />} />
          <Route path="trips/:id" element={<TripDetailPage />} />
          <Route path="tasks" element={<TasksPage />} />
          <Route path="tasks/new" element={<TaskCreatePage />} />
          <Route path="tasks/:id" element={<TaskDetailPage />} />
          <Route path="more" element={<MorePage />} />
          <Route path="kb" element={<KbSpacesPage />} />
          <Route path="kb/:spaceKey" element={<KbSpacePage />} />
          <Route path="kb/:spaceKey/:pageId" element={<KbArticlePage />} />
          <Route path="queue" element={<QueuePage />} />
          <Route path="video" element={<VideoCallsScreen />} />

          {/* Разделы из «Ещё» — не в основной навигации по требованию брифа */}
          <Route path="cars" element={<CarsPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="verify" element={<VerificationWizard />} />
          <Route path="chat" element={<ChatListPage />} />
          <Route path="chat/saved" element={<SavedPage />} />
          <Route path="chat/:id" element={<ChatPage />} />
          <Route path="support" element={<SupportPage />} />
          <Route path="support/new" element={<CreateTicketPage />} />
          <Route path="support/:id" element={<TicketChat />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
